import { put } from 'redux-saga/effects';

import { send } from '../../helpers/requests';
import * as actions from './actions';

export function* checkSamlAuthRequestSaga() {
  try {
    const res = yield send({
      url: `/admin/is-authenticated`,
      method: 'GET',
      saml: true,
      skipToast: true,
      credentials: 'include',
    });
    yield put(actions.checkSamlAuthRequestSuccess(res));
  } catch (error) {
    yield put(actions.checkSamlAuthRequestFailure(error));
  }
}
